import { createVersionUpdate, readVersionCheckSettings } from '@srm/core/version';
import { ConfigService } from '@/configuration/services/configService';

/**
 * Предложение обновить фронтенд — одно на вкладку (`@srm/core/version`). Заполняют проверка `version.json`
 * (`@/errorHandling`) и ответ сервера «обновитесь» (плагин версии клиента `@/http`), показывает окно в App
 * (`ConnectedVersionUpdateDialog`). «Позже» откладывает на `versionCheck.snoozeMinutes` конфига; несохранённые правки
 * черновика уходят на сервер при перезагрузке (pagehide).
 */
export const versionUpdate = createVersionUpdate({
    snoozeMs: () => readVersionCheckSettings(() => ConfigService.get().application.versionCheck).snoozeMs,
});
